import { connect } from 'react-redux';
import { List } from 'immutable';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadCognitoFormAdmin,
  updateCognitoFormAdmin,
  createCognitoFormAdmin,
  deleteCognitoFormAdmin,
  cognitoFormAdminFormDestroy,
  cognitoFormAdminHideForm,
  cognitoFormAdminShowForm,
  loadCognitoFormsAdmin,
} from '../../../../../state/modules/cognitoFormsAdmin/actions';
import CognitoFormModalFormAdmin from '../components/CognitoFormModalFormAdmin';

import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List([
  'registration_code_id',
  'type',
  'name',
  'form_id',
  'form_key',
  'public_status',
  'cognito_forms_care_guide_partner_tags',
  'new_user_requirement',
  'old_user_requirement',
  'old_user_requirement_frequency_type',
  'old_user_requirement_repeat_every',
  'old_user_requirement_repeat_unit',
]);

const mapStateToProps = (state, ownProps) => {
  const errors = {};
  const id = state.cognitoFormsAdmin.get('id');

  for (const val of inputs.values()) {
    errors[val] = state.cognitoFormsAdmin.getIn(['form', 'errors', val]);
  }

  const cognitoForm = id
    ? denormalize(
        state.entities.getIn(['cognitoFormsAdmin', id]),
        schema.cognitoFormAdmin,
        state.entities.toJS()
      )
    : null;

  const data = {
    type: cognitoForm?.type ?? 1,
    cognito_form_id: cognitoForm?.cognito_form_id ?? '',
    registration_code_id: cognitoForm?.registration_code?.id ?? null,
    public_status: cognitoForm?.public_status ?? 1,
    cognito_forms_care_guide_partner_tags: cognitoForm
      ? cognitoForm.cognito_forms_care_guide_partner_tags
      : [],
    name: cognitoForm?.name ?? '',
    form_id: cognitoForm?.form_id ?? '',
    form_key: cognitoForm?.form_key ?? '',
    new_user_requirement: cognitoForm?.new_user_requirement ?? null,
    old_user_requirement: cognitoForm?.old_user_requirement ?? null,
    old_user_requirement_frequency_type:
      cognitoForm?.old_user_requirement_frequency_type ?? null,
    old_user_requirement_repeat_every:
      cognitoForm?.old_user_requirement_repeat_every ?? null,
    old_user_requirement_repeat_unit:
      cognitoForm?.old_user_requirement_repeat_unit ?? null,
  };

  return {
    visible: state.cognitoFormsAdmin.get('isFormVisible'),
    isLoading: state.cognitoFormsAdmin.get('isLoading'),
    isSubmitting: state.cognitoFormsAdmin.getIn(['form', 'isSubmitting']),
    data: data,
    errors: errors,
    id: id,
    createdAt: state.entities.getIn(
      ['cognitoFormsAdmin', ownProps.id, 'created_at'],
      null
    ),
    updatedAt: state.entities.getIn(
      ['cognitoFormsAdmin', ownProps.id, 'updated_at'],
      null
    ),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    inputs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, id, cb) => {
      dispatch(loadCognitoFormAdmin(partnershipId, id, cb));
    },
    loadList: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadCognitoFormsAdmin(partnershipId, page, limit, order, filter, cb)
      );
    },
    update: (id, data, cb) => {
      dispatch(updateCognitoFormAdmin(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createCognitoFormAdmin(data, cb));
    },
    delete: (partnershipId, id, cb) => {
      dispatch(deleteCognitoFormAdmin(partnershipId, id, cb));
    },
    destroyForm: (formState) => {
      dispatch(cognitoFormAdminFormDestroy(formState));
    },
    hideForm: () => {
      dispatch(cognitoFormAdminHideForm());
    },
    showForm: (id) => {
      dispatch(cognitoFormAdminShowForm(id));
    },
  };
};

const CognitoFormModalFormAdminContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormModalFormAdmin);

export default CognitoFormModalFormAdminContainer;
